import { render } from "./XLoginCheck.vue?vue&type=template&id=0c2fa134&scoped=true"
import script from "./XLoginCheck.vue?vue&type=script&lang=js"
export * from "./XLoginCheck.vue?vue&type=script&lang=js"

import "./XLoginCheck.vue?vue&type=style&index=0&id=0c2fa134&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2fa134"]])

export default __exports__